document.addEventListener('DOMContentLoaded', function () {
  const tabs = document.querySelectorAll('.tab-button');
  const contents = document.querySelectorAll('.tab-content');
  const footerLinks = document.querySelectorAll('footer a[href*="#"]');

  function updateFooterLinks(activeTabId) {
    footerLinks.forEach((link) => {
      const linkHash = link.getAttribute('href').split('#')[1];
      if (linkHash === activeTabId) {
        link.classList.add('tab-link-active');
      } else {
        link.classList.remove('tab-link-active');
      }
    });
  }

  function showTab(tabId) {
    contents.forEach((content) => {
      content.classList.remove('active');
    });
    tabs.forEach((tab) => {
      tab.classList.remove('active');
    });

    const targetContent = document.getElementById(tabId);
    const targetTab = document.querySelector(`[data-tab="${tabId}"]`);

    if (targetContent && targetTab) {
      targetContent.classList.add('active');
      targetTab.classList.add('active');
      updateFooterLinks(tabId);
    }
  }

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      const tabId = tab.dataset.tab;
      showTab(tabId);
      // Update URL without page reload
      history.pushState(null, '', `#${tabId}`);
    });
  });

  // Handle hash changes (including clicks on footer links)
  window.addEventListener('hashchange', function () {
    if (window.location.hash) {
      const tabId = window.location.hash.substring(1);
      showTab(tabId);
    }
  });

  // Check for hash in URL and show corresponding tab
  if (window.location.hash) {
    const tabId = window.location.hash.substring(1);
    showTab(tabId);
  } else if (tabs.length > 0) {
    // Show first tab by default
    showTab(tabs[0].dataset.tab);
  }
});
